import { useDispatch, useSelector } from "react-redux";

import { ActionCreators as UndoActionCreators } from "redux-undo";
import { getRedoDisabled, getUndoDisabled } from "../../../redux/selectors";
import { Button, Tooltip } from "antd";
import UndoIcon from "remixicon-react/ArrowGoBackLineIcon";
import RedoIcon from "remixicon-react/ArrowGoForwardLineIcon";
import { iconSize } from "../../../config";
import { ctrlKeySymbol } from "../../../util/platform";

export function UndoRedo() {
  const undoDisabled = useSelector(getUndoDisabled);
  const redoDisabled = useSelector(getRedoDisabled);
  const dispatch = useDispatch();
  const undo = () => {
    dispatch(UndoActionCreators.undo());
  };
  const redo = () => {
    dispatch(UndoActionCreators.redo());
  };
  return (
    <>
      <Tooltip
        title={
          undoDisabled ? null : (
            <span>
              Undo
              <br />(<kbd>{ctrlKeySymbol}</kbd>
              <kbd>Z</kbd>)
            </span>
          )
        }
      >
        <Button
          type="text"
          onClick={undo}
          disabled={undoDisabled}
          icon={<UndoIcon size={iconSize} />}
        />
      </Tooltip>
      <Tooltip
        title={
          redoDisabled ? null : (
            <span>
              Redo
              <br />(<kbd>{ctrlKeySymbol}</kbd>(<kbd>Y</kbd>)
            </span>
          )
        }
      >
        <Button
          type="text"
          onClick={redo}
          disabled={redoDisabled}
          icon={<RedoIcon size={iconSize} />}
        />
      </Tooltip>
    </>
  );
}
